// @ts-check
import { createContext, useContext } from 'react';

/**
 * @typedef {Object} AIPanelContextValue
 * @property {(content: import('react').ReactNode) => void} openPanel - Opens the panel with the given content,
 *   usually an element that renders an AIPanel. Focus returns to whatever had it when this was called.
 * @property {() => void} closePanel
 * @property {boolean} isOpen
 */

/** Kept apart from the provider component so the provider file only exports a component. */
export const AIPanelContext = createContext(/** @type {AIPanelContextValue|null} */ (null));

/** @returns {AIPanelContextValue} */
export const useAIPanel = () => {
  const context = useContext(AIPanelContext);

  if (!context) {
    throw new Error('useAIPanel must be used inside AIPanelProvider');
  }

  return context;
};
